import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=7f387fb5&scoped=true"
import script from "./HeaderBar.vue?vue&type=script&lang=ts"
export * from "./HeaderBar.vue?vue&type=script&lang=ts"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=7f387fb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f387fb5",
  null
  
)

export default component.exports